import { mapEnumToOptions } from '@abp/ng.core';

export enum QuestionType {
  Dropdown = 0,
  FreeText = 1,
  Date = 2,
  Conditional = 3,
}

export const questionTypeOptions = mapEnumToOptions(QuestionType);
